import { nothing, svg } from 'lit';
import { bounds, highlightStateProvider } from '../../../types.js';
import { curvedSegment } from '../../types.js';
import { AreaRenderGroup } from '../types.js';
import { interpolate, svgTransition } from '../../../../common/directives/svgTransition.js';
import { timing } from '../../../animation.js';
import { getCurvedAreaPathData, getCurvedLinePathData } from '../../paths.js';
import { vector } from '../../../../common/types.js';
import { seriesOpacityOnInactiveHighlight } from '../../../style.js';
export function CurvedArea({
  segment,
  group,
  boundary,
  domainPosition,
  animate,
  highlightStateProvider
}: {
  segment: curvedSegment;
  group: AreaRenderGroup;
  boundary: bounds;
  domainPosition: number;
  animate: boolean;
  highlightStateProvider: highlightStateProvider;
}) {
  return [SvgCurvedAreaPath({
    segment,
    group,
    boundary,
    domainPosition,
    animate,
    highlightStateProvider
  }), SvgCurvedLinePath({
    segment,
    group,
    boundary,
    animate,
    highlightStateProvider
  })];
}
function SvgCurvedAreaPath({
  segment,
  group,
  boundary,
  domainPosition,
  animate,
  highlightStateProvider
}: {
  segment: curvedSegment;
  group: AreaRenderGroup;
  boundary: bounds;
  domainPosition: number;
  animate: boolean;
  highlightStateProvider: highlightStateProvider;
}) {
  const opacity = highlightStateProvider(group.name) === 'inactive' ? seriesOpacityOnInactiveHighlight : 0.3;
  return svg`<path
    fill=${group.color}
    ${svgTransition({
    timing: timing(animate),
    attributes: {
      opacity: interpolate.standard(0, opacity, 0),
      d: interpolate.constant([boundary.top, boundary.right, boundary.bottom, boundary.left, segment.ghostStartPoint[0], segment.ghostStartPoint[1], segment.startPoint[0], segment.startPoint[1], segment.endPoint[0], segment.endPoint[1], segment.ghostEndPoint[0], segment.ghostEndPoint[1], domainPosition], ([top, right, bottom, left, ghostStartPointX, ghostStartPointY, startPointX, startPointY, endPointX, endPointY, ghostEndPointX, ghostEndPointY, domainPosition]) => {
        const interpolatedBoundary = {
          top,
          right,
          bottom,
          left
        };
        const interpolatedLine: vector[] = [[ghostStartPointX, ghostStartPointY], [startPointX, startPointY], [endPointX, endPointY], [ghostEndPointX, ghostEndPointY]];
        return getCurvedAreaPathData(interpolatedLine, interpolatedBoundary, domainPosition).toString();
      })
    }
  })}
  />`;
}
function SvgCurvedLinePath({
  segment,
  group,
  boundary,
  animate,
  highlightStateProvider
}: {
  segment: curvedSegment;
  group: AreaRenderGroup;
  boundary: bounds;
  animate: boolean;
  highlightStateProvider: highlightStateProvider;
}) {
  const opacity = highlightStateProvider(group.name) === 'inactive' ? seriesOpacityOnInactiveHighlight : 1;
  return svg`<path
    stroke=${group.color}
    stroke-linecap="round"
    stroke-width=${group.strokeWidth}
    stroke-dasharray=${group.strokeDashed !== '' ? group.strokeDashed : nothing}

    ${svgTransition({
    timing: timing(animate),
    attributes: {
      opacity: interpolate.standard(0, opacity, 0),
      d: interpolate.constant([boundary.top, boundary.right, boundary.bottom, boundary.left, segment.ghostStartPoint[0], segment.ghostStartPoint[1], segment.startPoint[0], segment.startPoint[1], segment.endPoint[0], segment.endPoint[1], segment.ghostEndPoint[0], segment.ghostEndPoint[1]], ([top, right, bottom, left, ghostStartPointX, ghostStartPointY, startPointX, startPointY, endPointX, endPointY, ghostEndPointX, ghostEndPointY]) => {
        const interpolatedBoundary = {
          top,
          right,
          bottom,
          left
        };
        const interpolatedLine: vector[] = [[ghostStartPointX, ghostStartPointY], [startPointX, startPointY], [endPointX, endPointY], [ghostEndPointX, ghostEndPointY]];
        return getCurvedLinePathData(interpolatedLine, interpolatedBoundary).toString();
      })
    }
  })}
  />`;
}